import { render, staticRenderFns } from "./inventoryStockToExamins.vue?vue&type=template&id=a1b07328&scoped=true"
import script from "./inventoryStockToExamins.vue?vue&type=script&lang=js"
export * from "./inventoryStockToExamins.vue?vue&type=script&lang=js"
import style0 from "./inventoryStockToExamins.vue?vue&type=style&index=0&id=a1b07328&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b07328",
  null
  
)

export default component.exports